import ObservableBaseModel from '../model/ObservableBaseModel';
import Session from './Session';
import ModelArray from './ModelArray';
import Booking from './Booking';
import Ticket from './Ticket';
import ConcessionItem from './ConcessionItem';
import VistaDate from './VistaDate'
import OrderService from '../service/order-service';
import EcomTrackingService from '../service/ecom-tracking-service';
import RegionService from '../service/region-service';

export default class Order {

    constructor(data = undefined) {
        // super();
        this.SessionId = undefined;
        this.CinemaId = undefined;
        this.Concessions = undefined;
        this.Sessions = [];
        this.Loyalties = [];
        this.modified = false;
        this.defaultTicketType = undefined;
        this.LastUpdated = undefined
        this.ExpiryDate = undefined
        this._loading = false;
        this.VistaBookingNumber = undefined;
        this.VistaTransactionNumber = undefined;
        this.seatGridLoaded = false;
        this._ticketFlow = {
            tickets: {add: [], remove: [], added: [], added_as_loyalty: []},
            loyalties: {add: [], remove: [], added: []},
            concessions: {add: [], remove: [], added: []}
        };
        this.toggleMaxAmountPurchaseDialog = false;
        // this.TicketTypes = [];
        if (data) {
            this.setOrder(data);
        }

        this.confirmAndReconfigureOrderSession();

        this.MaxTotal = 500000;
        this.getMaxTotal();
    }

    get loading() {
        return this._loading || (this.Session && this.Session._loadingGrid)
    }

    get ORDER_MODIFIED() {
        return "ORDER_MODIFIED";
    }

    get ORDER_TICKET_MODIFIED() {
        return "ORDER_TICKET_MODIFIED"
    }

    get ORDER_CONCESSION_MODIFIED() {
        return "ORDER_CONCESSION_MODIFIED"
    }

    get hasTickets() {
        return this.Tickets.length > 0 && this.Session.Tickets.length > 0;
    }

    get Session() {

        return this.Sessions ? this.Sessions.find((s) => s.SessionId === parseInt(this.SessionId)) : {};
    }

    get Experiences() {
        return this.Sessions ? this.Sessions.reduce((c, s) => {
            c = c.concat(s.MovieSession.experiences);
            return c
        }, []) : [];
    }

    get Genres() {
        return this.Sessions ? this.Sessions.reduce((c, s) => {
            c = c.concat(s.movie.genres);
            return c
        }, []) : [];
    }

    getMaxTotal() {
        Promise.resolve(OrderService.getPaymentConfig()).then((result) => {
            if (result.data) {
                let maxTotal = parseInt(result.data[0].max_amount)
                this.MaxTotal = maxTotal * 100
            }
        })

    }

    /**
     *
     * retrieves a flattened list of loyalties - if a loyalty contains a Packaged Content Ticket, it will create virtual loyalties with a value of 0 up to the quantity of the tickets in the package.
     * @returns {Array}
     * @constructor
     */
    get AllLoyalties() {
        return this.getSessionLoyalties(this.Session);
    }

    confirmAndReconfigureOrderSession() {
        if (!this.Session && this.Sessions.length > 0) {
            this.SessionId = this.Sessions[0].SessionId;
            if (this.Session.MoviePromise)
                this.Session.MoviePromise.then((m) => {
                    OrderService.setPendingSession(this.SessionId, this.CinemaId, m ? m.id : null);
                });
            else
                OrderService.setPendingSession(this.SessionId, this.CinemaId, null);
            this.loadSeatGrid();

        }
    }

    getSessionLoyalties(session) {
        // return session.Loyalties
        // console.log(session)
        return session && session.Loyalties && session.Loyalties.length > 0 ? session.Loyalties.reduce((collection, loyalty) => {
            // console.log("loyalty",loyalty)
            if (loyalty.TicketType && loyalty.TicketType.PackageContent && loyalty.TicketType.PackageContent.Tickets) {
                loyalty.PackageTicket = false;
                
                let added = false;
                
                // if(loyalty.TicketType.isPackageTicket && loyalty.TicketType.Description.includes("4for3")) {
                    if(loyalty.TicketType.PackageContent != undefined && loyalty.TicketType.PackageContent != null) {
                        if(loyalty.TicketType.PackageContent.Tickets != undefined && loyalty.TicketType.PackageContent.Tickets != null) {
                            // console.log("PackageTicket length",loyalty.TicketType.PackageContent.Tickets.length)
                            for (var i = 0; i < loyalty.TicketType.PackageContent.Tickets.length; i++) {
                                var ticket = loyalty.TicketType.PackageContent.Tickets[i];
                                // console.log("loyalty ticket",ticket)
                                for (var j = 1; j <= ticket.Quantity; j++) {
                                    var loyaltyClone = Object.assign({}, loyalty);
                                    loyaltyClone.TicketType = Object.assign({}, loyaltyClone.TicketType);
                                    loyaltyClone.TicketType.PriceInCents = 0;
                                    loyaltyClone.PackageTicket = true;
                                    collection.push(loyaltyClone);
                                    added = true
                                }
                            }
                        }
                    }

                    if(!added) {
                        collection.push(loyalty);
                    }
                // }
            }


            return collection;
        }, []) : [];
    }

    get Tickets() {
        let loyaltyIndex = {};
        // console.log("sessions", this.Session)
        let tickets = this.Session && this.Session.Tickets ? this.Session.Tickets.map((ticket) => {
            if (ticket.Position) {
                var tAreaCat = ticket.Position.AreaCategoryCode;
                loyaltyIndex[tAreaCat] = loyaltyIndex[tAreaCat] === undefined ? 0 : loyaltyIndex[tAreaCat] + 1;
                ticket.index = loyaltyIndex[tAreaCat];
                var loyalty = this.AllLoyalties.length > 0 ? ((this.AllLoyalties.filter((l) => l.TicketType.AreaCategoryCode == tAreaCat))[loyaltyIndex[tAreaCat]] || undefined) : undefined;

                if (loyalty && loyalty.TicketType && (!ticket.Id || ticket.Description != loyalty.TicketType.Description)) {

                    var maskedTicket = Object.assign({}, ticket);

                    maskedTicket.PriceCents = !ticket.Id ? loyalty.TicketType.PriceInCents : maskedTicket.PriceCents;
                    if(loyalty.TicketType.IsPackageTicket) {
                        maskedTicket.PriceCents = loyalty.ApprovedPriceInCents
                        maskedTicket.PriceInCents = loyalty.ApprovedPriceInCents
                        ticket.PriceInCenters = loyalty.ApprovedPriceInCents
                        ticket.PriceCents = loyalty.ApprovedPriceInCents
                    }
                    maskedTicket.PackageTicket = loyalty.PackageTicket;
                    maskedTicket.TicketTypeCode = loyalty.TicketType.TicketTypeCode;
                    maskedTicket.Description = loyalty.TicketType.Description;
                    maskedTicket.ThirdPartyMemberScheme = {MemberCard: loyalty.CardNumber};
                    if (loyalty.Barcode) {
                        maskedTicket.Barcode = loyalty.Barcode
                    }
                    if (loyalty.RecognitionID) {
                        maskedTicket.LoyaltyRecognitionId = loyalty.RecognitionID
                        maskedTicket.LoyaltyRecognitionSequence = loyalty.SequenceNumber
                    }
                    return maskedTicket;
                } //else loyaltyIndex[tAreaCat] -=  1;
            }
            return ticket;
        }) : [];
        return tickets
    }

    get TicketTypes() {
        return this.Session ? this.Session.TicketTypes : [];
    }


    get AllTickets() {

        var Tickets = [];
        for (var i = 0; i < this.Sessions.length; i++) {
            var Session = this.Sessions[i];
            var AllLoyalties = this.getSessionLoyalties(Session);
            var loyaltyIndex = {};
            var formattedTickets = Session.Tickets.map((ticket) => {
                if (ticket.Position) {
                    var tAreaCat = ticket.Position.AreaCategoryCode;
                    loyaltyIndex[tAreaCat] = loyaltyIndex[tAreaCat] === undefined ? 0 : loyaltyIndex[tAreaCat] + 1;
                    ticket.index = loyaltyIndex[tAreaCat];
                    var loyalty = AllLoyalties.length > 0 ? ((AllLoyalties.filter((l) => l.TicketType.AreaCategoryCode == tAreaCat))[loyaltyIndex[tAreaCat]] || undefined) : undefined;
                    if (loyalty && loyalty.TicketType && (!ticket.Id || ticket.Description != loyalty.TicketType.Description)) {
                        var maskedTicket = Object.assign({}, ticket);
                        maskedTicket.PriceCents = !ticket.Id ? loyalty.TicketType.PriceInCents : maskedTicket.PriceCents;
                        maskedTicket.PackageTicket = loyalty.PackageTicket;
                        maskedTicket.TicketTypeCode = loyalty.TicketType.TicketTypeCode;
                        maskedTicket.Description = loyalty.TicketType.Description;
                        maskedTicket.ThirdPartyMemberScheme = {MemberCard: loyalty.CardNumber};
                        if (loyalty.Barcode) {
                            maskedTicket.Barcode = loyalty.Barcode
                        }
                        if (loyalty.RecognitionID) {
                            maskedTicket.LoyaltyRecognitionId = loyalty.RecognitionID
                            maskedTicket.LoyaltyRecognitionSequence = loyalty.SequenceNumber
                        }
                        return maskedTicket;
                    }
                }
                return ticket;
            })
            Tickets = Tickets.concat(formattedTickets)
        }
        return Tickets;

    }

    get UnassignedTickets() {
        return this.Session ? this.Session.UnassignedTickets : [];
    }

    get SessionDate() {
        if (this.Session) {
            return this.Session.ShowingRealDateTime;
        }
    }

    get SessionEndDate() {
        if (this.SessionDate && this.Session.movie) {
            return new VistaDate(this.SessionDate.date.clone().add(this.Session.movie.runtime, 'minutes'));
        }

    }

    get totalInCents() {

        var ticketTotal = this.AllTickets ? this.AllTickets.reduce((c, t) => c += t.PriceCents, 0) : 0
        var ConcessionTotal = this.Concessions ? this.Concessions.reduce((c, t) => c += (t.PriceInCents * t.Quantity), 0) : 0

        return ticketTotal + ConcessionTotal;
    }

    get total() {
        var ticketTotal = this.AllTickets ? this.AllTickets.reduce((c, t) => c += t.PriceCents, 0) : 0;
        var ConcessionTotal = this.Concessions ? this.Concessions.reduce((c, t) => c += (t.PriceInCents * t.Quantity), 0) : 0

        var priceFormatted = ((ticketTotal + ConcessionTotal) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        return `R${priceFormatted}`
    }

    get TicketsForSeating() {
        let tickets = []
        if(this.Session && this.Session.Tickets) {
            for(let i = 0; i < this.Session.Tickets.length; i++) {
                let ticket = this.Session.Tickets[i]

                if(ticket.IsTicketPackage) {
                    if(ticket.PackageTickets) {
                        for(let p = 0; p < ticket.PackageTickets.length; p++) {
                            let p_ticket = ticket.PackageTickets[p]
                            if(ticket.Barcode !== null) {
                                p_ticket.Barcode == ticket.Barcode
                                p_ticket.SelectedButNotChangeable = true
                            }

                            tickets.push(p_ticket)
                        }
                    }
                } else {
                    ticket.SelectedButNotChangeable = false
                    tickets.push(ticket)
                }
            }
        }
        let ticketTypes = this.TicketTypes
        for(let t = 0; t < tickets.length; t++) {
            for(let k = 0; k < ticketTypes.length; k++) {
                let ticketType = ticketTypes[k]
                if(ticketType.TicketTypeCode == tickets[t].TicketTypeCode) {
                    if(ticketType.IsThirdPartyMemberTicket || ticketType.IsRedemptionTicket && tickets[t].SelectedButNotChangeable == false) {
                        p_ticket.SelectedButNotChangeable = true
                    }
                }
            }
        }

        return tickets
    }

    getDefaultTicketTypeForArea(AreaCategoryCode) {
        return this.TicketTypes.find((type) => type.default === true && type.AreaCategoryCode === AreaCategoryCode);
    }

    setOrder(data) {
        if (data instanceof Order) {
            Object.assign(this, data);
            return this;
        }

        if (!data) return this;
        this.SessionId = data.SessionId;
        this.CinemaId = data.CinemaId;

        this.Concessions = data.Concessions ? new ModelArray(data.Concessions, ConcessionItem) : [];
        this.Sessions = data.Sessions ? new ModelArray(data.Sessions, Session) : [];
        this.modified = false;
        this.defaultTicketType = data.defaultTicketType;
        this._loading = data.loading || false;
        this.VistaBookingNumber = data.VistaBookingNumber;
        this.VistaTransactionNumber = data.VistaTransactionNumber;

        this.LastUpdated = data.LastUpdated ? new VistaDate(data.LastUpdated / 1000) : this.LastUpdated;
        this.ExpiryDate = data.ExpiryDate ? new VistaDate(data.ExpiryDate / 1000) : this.ExpiryDate;
        return this;
    }

    setDates(Expiry, Updated) {
        this.LastUpdated = new VistaDate(Updated / 1000) || false;
        this.ExpiryDate = new VistaDate(Expiry / 1000) || false;
    }

    addTicket(seat, seatProps) {
        var TicketType = this.getDefaultTicketTypeForArea(seat.Position.AreaCategoryCode);
        if ((this.totalInCents + TicketType.PriceInCents) > this.MaxTotal) {
            this.toggleMaxAmountPurchaseDialog = true
        } else {
            this.modified = true;
            var ticket = new Ticket({
                Position: seat.Position,
                SeatData: seat.seatName,
                SeatName: seat.seatName,
                SeatNumber: seat.seatNumber || seatProps.seatNumber,
                SeatId: seat.Id,
                SeatNumberCombined: seatProps.SeatNumberCombined,
                PriceCents: TicketType.PriceInCents,
                TicketTypeCode: TicketType.TicketTypeCode,
                isPackageTicket: TicketType.IsPackageTicket,
                Description: TicketType.Description,
                // ThirdPartyMemberScheme: {MemberCard: null},
                Barcode: null,
            });
            ticket.status = {
                companion: seatProps.companion,
                loveNest: seatProps.loveNest,
                dBox: seatProps.dBox,
                wheelchair: seatProps.wheelchair,
            };
            this.Session.Tickets.push(ticket)
            this._ticketFlow.tickets.add.push(ticket)
            this._processEcomTrackingCart()
            // this.notifyMultipleObservers([this.ORDER_MODIFIED, this.ORDER_TICKET_MODIFIED], ticket);

            return ticket
        }
    }

    addVistaVoucherTicket(LoyaltyCard) {
        let Qty = 1
        let TicketTypeCode = LoyaltyCard.TicketTypeCode
        let AreaCategoryCode = LoyaltyCard.TicketType.AreaCategoryCode
        let TicketType = this.getDefaultTicketTypeForArea(AreaCategoryCode)
        let OriginalTicketTypeCode = TicketType.TicketTypeCode
        let sessionId = this.SessionId
        let Barcode = LoyaltyCard.Barcode

        return OrderService.addVistaVoucherTicket(sessionId, Qty, TicketTypeCode, OriginalTicketTypeCode, AreaCategoryCode, Barcode)
    }

    removeVistaVoucherTicket(ticket) {
        //console.log("Order::removeVistaVoucherTicket", ticket)
        let sessionId = this.SessionId
        let cinemaId = this.SessionId
        return OrderService.removeVistaVoucherTicket(sessionId, cinemaId, ticket)
    }

    addVistaSeatsForTicket(seat, seatProps, SuppliedTicketType = undefined) {
        return OrderService.getDefaultTicketTypeForSession(this.SessionId, this.CinemaId, seat.Position.AreaCategoryCode).then(TicketType => {
            if ((this.totalInCents + TicketType.PriceInCents) > this.MaxTotal) {
                this.toggleMaxAmountPurchaseDialog = true
            } else {
                this.modified = true;
                var ticket = new Ticket({
                    Position: seat.Position,
                    SeatData: seat.seatName,
                    SeatName: seat.seatName,
                    SeatNumber: seat.seatNumber || seatProps.seatNumber,
                    SeatId: seat.Id,
                    SeatNumberCombined: seatProps.SeatNumberCombined,
                    PriceCents: TicketType.PriceInCents,
                    TicketTypeCode: TicketType.TicketTypeCode,
                    isPackageTicket: TicketType.IsPackageTicket,
                    Description: TicketType.Description,
                    Barcode: null,
                });
                ticket.status = {
                    companion: seatProps.companion,
                    loveNest: seatProps.loveNest,
                    dBox: seatProps.dBox,
                    wheelchair: seatProps.wheelchair,
                };
            }
            return OrderService.addVistaSeatsForTicket(ticket, this.SessionId)
        })


    }

    removeVistaSeatsForTicket(seat, seatProps, ticketTypeCode) {
        let position = seat.Position
        let status = {
            companion: seatProps.companion,
            loveNest: seatProps.loveNest,
            dBox: seatProps.dBox,
            wheelchair: seatProps.wheelchair,
        }

        console.log("Order::removeVistaTicket", position, ticketTypeCode, this.SessionId)
        return OrderService.removeVistaSeatsForTicket(position, status, ticketTypeCode, this.SessionId)
    }

    addLoyalty(LoyaltyCard, validCardResponse = {}) {
        for (var i = 0; i < this.Tickets.length; i++) {
            var ticket = this.Tickets[i];
            if (ticket.Id) {
                this.UnassignedTickets.push(Object.assign({}, ticket));
                delete ticket.Id
            }
        }

        //console.log("LoyaltyCard", LoyaltyCard)

        try {
            var loyalties = []
            try {
                loyalties = JSON.parse(localStorage.getItem("loyalties")) || [];
            } catch (e) {

            }
            var thisLoyalty = {
                "SessionId": this.SessionId,
                "MemberCard": LoyaltyCard.MemberCard,
                "CardNumber": LoyaltyCard.CardNumber,
                "TicketTypeCode": LoyaltyCard.TicketTypeCode,
                "Name": LoyaltyCard.Name,
                "MemberProviderName": LoyaltyCard.MemberProviderName
            };
            if (!~loyalties.indexOf(thisLoyalty))
                loyalties.push(thisLoyalty);
            localStorage.setItem("loyalties", JSON.stringify(loyalties))
        } catch (e) {
        }
        this.modified = true;
        this.Session.Loyalties.push(LoyaltyCard);

        this._ticketFlow.loyalties.add.push(LoyaltyCard)
        this._processEcomTrackingCart()

    }

    removeLoyalty(LoyaltyCard) {
        let index = this.Session.Loyalties.indexOf(LoyaltyCard);
        this.Session.Loyalties.splice(index, 1);

        try {
            var loyalties = []
            try {
                loyalties = JSON.parse(localStorage.getItem("loyalties")) || [];
            } catch (e) {

            }

            let lIndex = loyalties.findIndex((l) => l.MemberCard == LoyaltyCard.MemberCard && l.Name == LoyaltyCard.Name);
            if (~lIndex)
                loyalties.splice(lIndex, 1);
            localStorage.setItem("loyalties", JSON.stringify(loyalties))

            this._ticketFlow.loyalties.remove.push(LoyaltyCard)
            this._processEcomTrackingCart()
        } catch (e) {
        }
    }

    removeTicket(ticket) {

        this.modified = true;
        if (ticket.Id) {
            this.UnassignedTickets.push(ticket);
        }
        if (ticket.PackageId && ticket.PackageId > 0 && ticket.Id == "0") {
            var parentTicket = this.Tickets.find((t) => parseInt(t.Id) > 0 && t.PackageId == ticket.PackageId);
            if (parentTicket) {

                this.UnassignedTickets.push(Object.assign({}, parentTicket));

                delete parentTicket.Id
            }
        }
        var index = this.Session.Tickets.indexOf(ticket)
        if (~index) {
            this.Session.Tickets.splice(index, 1);
            // this.notifyMultipleObservers([this.ORDER_MODIFIED, this.ORDER_TICKET_MODIFIED], ticket);
            this._ticketFlow.tickets.remove.push(ticket)
            this._processEcomTrackingCart()
            return true;
        }

        return false
    }

    _processEcomAddLinkLoyaltyToNewTicket(loyalty) {
        return false
        for (var t in this._ticketFlow.tickets.add) {
            // console.log("this._ticketFlow _processEcomAddLinkLoyaltyToNewTicket",this._ticketFlow.tickets.add[t])
            if (this._ticketFlow.tickets.add[t].TicketTypeCode == "0022" || this._ticketFlow.tickets.add[t].TicketTypeCode == "0008" || this._ticketFlow.tickets.add[t].Description.includes("Full Price")) {
                let ticket = loyalty.TicketType
                let b_ticket = this._ticketFlow.tickets.add[t]
                let session = this.Sessions[0]
                ticket.FilmTitle = session.FilmTitle
                b_ticket.FilmTitle = session.FilmTitle
                EcomTrackingService.doDataLayerAddTicketToBasket(ticket)
                this._ticketFlow.loyalties.added.push(loyalty)
                this._ticketFlow.tickets.added_as_loyalty.push(b_ticket)
                this._ticketFlow.tickets.add.splice(t, 1)

                return true
            }
        }

        return false
    }

    _processEcomAddLinkLoyaltyToAddedTicket(loyalty) {
        return false
        for (var t in this._ticketFlow.tickets.added) {
            // console.log("this._ticketFlow _processEcomAddLinkLoyaltyToAddedTicket",this._ticketFlow.tickets.added[t])
            if (this._ticketFlow.tickets.added[t].TicketTypeCode == "0022" || this._ticketFlow.tickets.added[t].TicketTypeCode == "0008" || this._ticketFlow.tickets.added[t].Description.includes("Full Price")) {
                let ticket = loyalty.TicketType
                let b_ticket = this._ticketFlow.tickets.added[t]
                let session = this.Sessions[0]
                ticket.FilmTitle = session.FilmTitle
                b_ticket.FilmTitle = session.FilmTitle
                // EcomTrackingService.doDataLayerAddTicketToBasket(ticket)
                EcomTrackingService.doDataLayerAddTicketToBasket(ticket)
                this._ticketFlow.loyalties.added.push(ticket)

                this._ticketFlow.tickets.added_as_loyalty.push(b_ticket)

                EcomTrackingService.doDataLayerRemoveTicketFromBasket(b_ticket)
                this._ticketFlow.tickets.added.splice(t, 1)


                return true
            }
        }

        return false
    }

    _processEcomRemoveLinkLoyaltyFromTicket(loyalty) {
        return false
        for (var t in this._ticketFlow.tickets.added_as_loyalty) {
            if (this._ticketFlow.tickets.added_as_loyalty[t].TicketTypeCode == "0022") {
                let ticket = loyalty.TicketType
                let b_ticket = this._ticketFlow.tickets.added_as_loyalty[t]
                let session = this.Sessions[0]
                ticket.FilmTitle = session.FilmTitle
                b_ticket.FilmTitle = session.FilmTitle
                EcomTrackingService.doDataLayerRemoveTicketFromBasket(ticket)
                EcomTrackingService.doDataLayerAddTicketToBasket(b_ticket)
                this._ticketFlow.tickets.added.push(b_ticket)
                this._ticketFlow.tickets.added_as_loyalty.splice(t, 1)

                for (var al in this._ticketFlow.loyalties.added) {
                    if (loyalty == this._ticketFlow.loyalties.added[al]) {
                        this._ticketFlow.loyalties.added.splice(al, 1)
                    }
                }

                return true
            }
        }
    }

    _processEcomAddNewTicket(ticket) {
        return false
        let session = this.Sessions[0]
        ticket.FilmTitle = session.FilmTitle
        EcomTrackingService.doDataLayerAddTicketToBasket(ticket)
        this._ticketFlow.tickets.added.push(ticket)
        return true
    }

    _processEcomRemoveAddedTicket(ticket) {
        return false
        for (var t in this._ticketFlow.tickets.added) {
            if (ticket == this._ticketFlow.tickets.added[t]) {
                EcomTrackingService.doDataLayerRemoveTicketFromBasket(ticket)
                this._ticketFlow.tickets.added.splice(t, 1)
                return true
            }
        }
    }

    _processEcomTrackingCart() {
        return false
        // link loyalty to ticket
        for (var l in this._ticketFlow.loyalties.add) {
            Promise.resolve(this._processEcomAddLinkLoyaltyToNewTicket(this._ticketFlow.loyalties.add[l])).then((result) => {
                if (result) {
                    this._ticketFlow.loyalties.add.splice(l, 1)
                } else {
                    Promise.resolve(this._processEcomAddLinkLoyaltyToAddedTicket(this._ticketFlow.loyalties.add[l])).then((result) => {
                        if (result) {
                            this._ticketFlow.loyalties.add.splice(l, 1)
                        }
                    })
                }
            })
        }

        //remove loyalty
        for (var rl in this._ticketFlow.loyalties.remove) {
            Promise.resolve(this._processEcomRemoveLinkLoyaltyFromTicket(this._ticketFlow.loyalties.remove[rl])).then((result) => {
                if (result) {
                    this._ticketFlow.loyalties.remove.splice(rl, 1)
                }
            })
        }

        // add new ticket
        for (var t in this._ticketFlow.tickets.add) {
            Promise.resolve(this._processEcomAddNewTicket(this._ticketFlow.tickets.add[t])).then((result) => {
                if (result) {
                    this._ticketFlow.tickets.add.splice(t, 1)
                }
            })
        }

        //remove ticket
        for (var rt in this._ticketFlow.tickets.remove) {
            Promise.resolve(this._processEcomRemoveAddedTicket(this._ticketFlow.tickets.remove[rt])).then((result) => {
                if (result) {
                    this._ticketFlow.tickets.remove.splice(rt, 1)
                }
            })
        }
    }

    removeSession(SessionId) {
        let foundIndex = this.Sessions.findIndex((s) => parseInt(s.SessionId) === parseInt(SessionId));
        if (~foundIndex) {
            this.Sessions.splice(foundIndex, 1);
            this.confirmAndReconfigureOrderSession();
        }
    }

    setConcession(concession, Quantity) {
        let session = this.Sessions[0]
        concession.FilmTitle = session.FilmTitle
        
        this.modified = true;
        if ((this.totalInCents + concession.PriceInCents) > this.MaxTotal && concession.Quantity < Quantity) {
            this.toggleMaxAmountPurchaseDialog = true
        } else {

            var index = this.Concessions.findIndex((c) => c.Id == concession.Id && c.Description == concession.Description);
            if (~index) {
                if (Quantity == 0) {
                    Promise.resolve(EcomTrackingService.doDataLayerRemoveConcessionFromBasket(concession)).then((result) => {
                        this.Concessions.splice(index, 1);
                        this._ticketFlow.concessions.remove.push(concession)
                        for (var rc in this._ticketFlow.concessions.added) {
                            if (this._ticketFlow.concessions.added[rc].Id == concession.Id) {
                                this._ticketFlow.concessions.added.splice(rc, 1)
                                break;
                            }
                        }

                    })
                } else {
                    if (this.Concessions[index].Quantity > Quantity) {
                        Promise.resolve(EcomTrackingService.doDataLayerRemoveConcessionFromBasket(concession)).then((result) => {
                            this._ticketFlow.concessions.remove.push(concession)
                            for (let rc in this._ticketFlow.concessions.added) {
                                this.Concessions[index].Quantity = Quantity;
                                if (this._ticketFlow.concessions.added[rc].Id == concession.Id) {
                                    this._ticketFlow.concessions.added.splice(rc, 1)
                                    break;
                                }

                            }

                        })
                    } else {
                        Promise.resolve(EcomTrackingService.doDataLayerAddConcessionToBasket(concession)).then((result) => {
                            this._ticketFlow.concessions.added.push(concession)
                            this.Concessions[index].Quantity = Quantity;
                        })
                    }
                }
            } else {
                Promise.resolve(EcomTrackingService.doDataLayerAddConcessionToBasket(concession)).then((result) => {
                    this._ticketFlow.concessions.added.push(concession)
                    this.Concessions.push(new ConcessionItem({
                        Id: concession.Id,
                        Quantity: Quantity,
                        Description: concession.Description,
                        PriceInCents: concession.PriceInCents,
                        RecognitionId: concession.RecognitionId,
                        RecognitionSequenceNumber: concession.RecognitionSequenceNumber,
                    }));
                })
            }
            concession.Quantity = Quantity;
        }
    }

    asBookings() {
        if (this.Sessions) {
            for (var i = 0; i < this.Sessions.length; i++) {
                var session = this.Sessions[i];
            }
        }
    }

    loadSeatGrid() {
        this.seatGridLoaded = false
        return this.Session ? this.Session.getSeatGrid().then((r) => {
            this.seatGridLoaded = true;
            return r;
        }, (e) => Promise.reject(e)) : Promise.reject("No Order");
        // return OrderService.getSeatGrid(this.SessionId, this.CinemaId, this.Session.Tickets).then((seatGrid)=>this.Session.SeatGrid = seatGrid, (error)=>Promise.reject(error));
    }

    _clearTracking() {
        this._ticketFlow = {
            tickets: {add: [], remove: [], added: [], added_as_loyalty: []},
            loyalties: {add: [], remove: [], added: []}
        };
    }

    save() {
        return OrderService.saveOrder(this)
    }

    toJSON() {
        return {
            CinemaId: this.CinemaId,
            SessionId: this.SessionId,
            Tickets: this.Tickets,
            UnassignedTickets: this.UnassignedTickets,
            Concessions: this.Concessions,
        }
    }
}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/Order.js